import React from "react";

import { connect } from "react-redux";
import PropTypes from "prop-types";
import {Login} from "@leap4/frontend"
import {Role} from "@leap4/auth"
import {urlsService} from "../Routing/urlsService";

const loginUrl = (process.env.REACT_APP_AUTH_SERVER_BASE_URL || "https://api.auth.adte-system.com") + "/users/login";

function LoginContainer(props:any) {

  const serviceURL = process.env.REACT_APP_BACKEND_BASE_URL

  const meRoute = `${serviceURL}/app/me`
  const setCookieURL = `${serviceURL}/app/setcookie`
  const serviceName = process.env.REACT_APP_SERVICE_NAME || ""

  return <Login user={props.user}
                redirectUrlForAuthenticated={urlsService.tasks()}
                meUrl={meRoute} setCookieUrl={setCookieURL}
                serviceName={serviceName} requiredRoles={[Role.ADMIN]}
                loginUrl={loginUrl}/>
}
LoginContainer.propTypes = {
  isAuthenticated: PropTypes.bool,
};
const mapStateToProps = (state:any) /**the param of the function */ => ({
  isAuthenticated: state.auth.isAuthenticated,
  user:state.auth.user
});

export default connect(mapStateToProps)(LoginContainer);
